import { createApi } from '@stilingue/st-auth-utils';
import Service from './Service';
import { StFeatureFlagFlags } from '@/plugins/rollout';
import { isProdVersion } from '@stilingue/st-environment-controller-utils';
import Cookies from 'js-cookie';

const afterParser = (response) => {
  return response.data;
};

const error401Handler = () => {
  console.error('Error in authentication');
  return false;
};

const authNotFound = () => {
  console.error('Authentication not found');
  return false;
};

const isStaging = !isProdVersion();

const gatewayProd = StFeatureFlagFlags.gatewayProd.getValue();
const gatewayStaging = StFeatureFlagFlags.gatewayStaging.getValue();

const version = !isStaging
  ? 'prod'
  : 'staging';
const gateway = !isStaging
  ? gatewayProd
  : gatewayStaging;

class SheetImporterTagsServiceV2 extends Service {
  constructor(accountId, universeId) {
    const api = createApi(`se-studio-endpoint/${version}/${accountId}/${universeId}/import/tag-posts/xlsx`, gateway, {
      authNotFound,
      error401Handler,
    });
    super(api, { afterParser });

    this.api.http.defaults.timeout = 300000;
  }

  importSheetToTagPosts(formdata, queryString) {
    const headers = {
      'stilingue-session-id': Cookies.get('stilingue-session-id'),
      'Content-Type': 'multipart/form-data',
    };
    const config = {
      params: queryString,
      crossDomain: true,
    };
    return this.update(formdata, config, { headers });
  }
}

export default SheetImporterTagsServiceV2;
